import { render, staticRenderFns } from "./IbCardEmptyChart.vue?vue&type=template&id=06bf5012&scoped=true"
import script from "./IbCardEmptyChart.vue?vue&type=script&lang=js"
export * from "./IbCardEmptyChart.vue?vue&type=script&lang=js"
import style0 from "./IbCardEmptyChart.vue?vue&type=style&index=0&id=06bf5012&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bf5012",
  null
  
)

export default component.exports